import { textareaField } from '../../../utils/field-config-helpers';

export const beforeAfterAppointmentFieldsConfig = {
  whatToBring: textareaField(),
  afterAppointmentIssue: textareaField(),
  afterAppointmentCare: textareaField(),
};

export type BeforeAfterAppointmentFieldsConfigTypes = typeof beforeAfterAppointmentFieldsConfig;
